var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3411 2.78998H12.9603C13.0813 2.78974 13.201 2.81336 13.3128 2.85947C13.4246 2.90558 13.5262 2.97328 13.6118 3.05869C13.6973 3.14411 13.7652 3.24557 13.8116 3.35726C13.8579 3.46894 13.8817 3.58867 13.8817 3.70959V12.3081",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47505 2.78998H9.46252",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6396 15.21H8.62708",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22047 5.69189V14.2904C4.21999 14.4112 4.2434 14.5308 4.28933 14.6425C4.33527 14.7542 4.40283 14.8556 4.48813 14.9411C4.57343 15.0266 4.67478 15.0943 4.78636 15.1405C4.89794 15.1866 5.01754 15.2103 5.13829 15.21H7.75935",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5809 4.16937C11.8248 4.16937 12.0587 4.26626 12.2312 4.43872C12.4037 4.61118 12.5005 4.84509 12.5005 5.08898",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28179 7.53115C9.28132 7.61578 9.24737 7.69677 9.18736 7.75645C9.12736 7.81612 9.04617 7.84962 8.96154 7.84961H5.92003C5.83557 7.84961 5.75457 7.81606 5.69484 7.75634C5.63512 7.69661 5.60157 7.61561 5.60157 7.53115V6.32886C5.60133 6.28689 5.6094 6.24528 5.62529 6.20644C5.64119 6.16759 5.66461 6.13228 5.69421 6.10251C5.7238 6.07275 5.75899 6.04913 5.79775 6.03302C5.8365 6.0169 5.87806 6.00861 5.92003 6.00861H8.96154C9.04648 6.00861 9.12793 6.04235 9.18799 6.10241C9.24805 6.16247 9.28179 6.24392 9.28179 6.32886V7.53115Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2014 6.47015H11.5808",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2014 7.84961H11.5808",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60168 9.229H11.3519",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60168 10.6102H11.3519",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60168 11.9896H11.3519",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60168 13.3708H8.36051",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46255 3.26049C9.49682 3.23027 9.52427 3.19311 9.54306 3.15146C9.56186 3.10982 9.57159 3.06465 9.57159 3.01896C9.57159 2.97327 9.56186 2.9281 9.54306 2.88646C9.52427 2.84482 9.49682 2.80765 9.46255 2.77743L7.50883 1.08671C7.46297 1.04349 7.40532 1.01484 7.34318 1.0044C7.28103 0.993961 7.21719 1.00219 7.15972 1.02805C7.10226 1.05391 7.05375 1.09624 7.02036 1.14967C6.98696 1.20311 6.97016 1.26525 6.9721 1.32824V1.86498C5.38676 1.86735 3.86721 2.49903 2.74738 3.62121C1.62755 4.74339 0.999051 6.26425 1 7.84959V8.08039L1.43476 7.34148C2.00343 6.37597 2.81415 5.57553 3.78683 5.01921C4.75952 4.4629 5.86051 4.16997 6.98104 4.16937V4.7061C6.97911 4.76909 6.9959 4.83124 7.0293 4.88467C7.0627 4.93811 7.1112 4.98044 7.16867 5.0063C7.22613 5.03215 7.28998 5.04038 7.35212 5.02994C7.41427 5.0195 7.47192 4.99086 7.51778 4.94764L9.46255 3.26049Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63961 14.7395C8.60495 14.7691 8.5771 14.8059 8.55796 14.8473C8.53881 14.8886 8.52883 14.9337 8.52869 14.9793C8.52878 15.0254 8.53873 15.0709 8.55786 15.1129C8.57699 15.1549 8.60486 15.1923 8.63961 15.2226L10.5933 16.9133C10.6392 16.9565 10.6968 16.9852 10.759 16.9956C10.8211 17.006 10.885 16.9978 10.9424 16.972C10.9999 16.9461 11.0484 16.9038 11.0818 16.8503C11.1152 16.7969 11.132 16.7348 11.1301 16.6718V16.135C12.7154 16.1327 14.235 15.501 15.3548 14.3788C16.4746 13.2566 17.1031 11.7358 17.1022 10.1504V9.91962L16.6674 10.6585C16.0987 11.624 15.288 12.4245 14.3153 12.9808C13.3426 13.5371 12.2417 13.83 11.1211 13.8306V13.2939C11.1217 13.2334 11.1052 13.1739 11.0736 13.1224C11.042 13.0708 10.9964 13.0292 10.9422 13.0023C10.8865 12.9769 10.8246 12.9681 10.764 12.977C10.7034 12.9859 10.6466 13.012 10.6005 13.0524L8.63961 14.7395Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5809 4.16937H9.62537",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5023 12.8627V5.08899",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.31a59a6c53d9727ff367765cdbac1ba5.svg";
export { ForwardRef as ReactComponent };